import { render } from "./CategorySort.vue?vue&type=template&id=6c896c3e&scoped=true"
import script from "./CategorySort.vue?vue&type=script&lang=js"
export * from "./CategorySort.vue?vue&type=script&lang=js"

import "./CategorySort.vue?vue&type=style&index=0&id=6c896c3e&lang=scss&scoped=true"
import "./CategorySort.vue?vue&type=style&index=1&id=6c896c3e&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c896c3e"]])

export default __exports__